import { themed } from "@smartsheet/sds-theme-internal";
import { mapButtonAppearance } from "./mapButtonAppearance";
var fontWeightTheme = themed({
  primary: 700,
  secondary: 600,
  destructive: 700,
  "secondary-destructive": 600,
  share: 700,
  borderless: 600,
  link: {
    "lodestar-light": 400,
    "ursa-light": 500
  },
  "primary-filled": 500,
  "primary-empty": 500,
  "secondary-filled": 500,
  "secondary-outlined": 500,
  "secondary-empty": 500,
  "canvas-filled": 500,
  "canvas-empty": 500,
  "destructive-filled": 500,
  "destructive-empty": 500
});
export var getButtonFontWeight = function getButtonFontWeight(_ref) {
  var appearance = _ref.appearance,
    themeMode = _ref.themeMode;
  return fontWeightTheme[mapButtonAppearance(appearance, themeMode)](themeMode);
};
var fontSizeTheme = themed({
  large: {
    "lodestar-light": "14px",
    "ursa-light": "14px"
  },
  medium: {
    "lodestar-light": "13px",
    "ursa-light": "14px"
  },
  small: {
    "lodestar-light": "13px",
    "ursa-light": "14px"
  },
  xsmall: {
    "lodestar-light": "13px",
    "ursa-light": "14px"
  }
});
var lineHeightTheme = themed({
  "lodestar-light": "18px",
  "ursa-light": "16px"
});
export var getButtonFontSize = function getButtonFontSize(_ref2) {
  var size = _ref2.size,
    themeMode = _ref2.themeMode;
  return fontSizeTheme[size](themeMode);
};
export var getButtonLineHeight = function getButtonLineHeight(_ref3) {
  var themeMode = _ref3.themeMode;
  return lineHeightTheme(themeMode);
};
//# sourceMappingURL=getButtonFontStyles.js.map